import { render, staticRenderFns } from "./PasswordResetConfirmation.vue?vue&type=template&id=fd3b1540&scoped=true&"
import script from "./PasswordResetConfirmation.vue?vue&type=script&lang=js&"
export * from "./PasswordResetConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3b1540",
  null
  
)

export default component.exports